import * as app from './scripts/app';
import * as Video from './scripts/common/video';
import * as Login from './scripts/common/login';
import * as Logout from './scripts/common/logout';
import './scripts/home/functions';
import * as Tablero from './scripts/common/tableros';
import * as TableroTenis from './scripts/common/tableros/tableroTenis';
import * as TableroVoley from './scripts/common/tableros/tableroVoley';
import * as TableroFutbol from './scripts/common/tableros/tableroFutbol';
import * as TableroRugby from './scripts/common/tableros/tableroRugby';
import * as TableroBasquet from './scripts/common/tableros/tableroBasket';
import * as Functions from './scripts/common/functions';
import * as personalizacionCommon from './scripts/common/personalizacion';
import * as personalizacionHomeBuilder from './scripts/home/personalizacion';
import * as Utilities from './scripts/common/utilities';
import * as CustomDimension from './scripts/common/analytics/CustomDimension';
import * as MetricsEvents from  './scripts/common/analytics/MetricsEvents';
import * as Pym from './scripts/common/pymFunction.js';
import * as videoJsonConfig from '../Settings/global/video.json';
import { prioridadTag } from '../Settings/global/home.json';
import { naveggCustomSegments } from '../Settings/global.json';
import * as customNavegg from './scripts/common/naveggCustom';
import * as pwaRegister from './scripts/common/pwa/register';
import * as Usuario from './scripts/home/usuarioHome';
import * as pvComscore from './scripts/home/pageviewComscore';
import * as isMobile from './scripts/common/isMobile';
import * as Modulos from './scripts/home/modulos';
import LazyLoad from './scripts/home/lazyload'

var FirstQuarter = false;
var SecondQuarter = false;
var ThirdQuarter = false;
var FourthQuarter = false;

const modulos = Modulos.init();

modulos
    .onLoad('ALL', () => getTableros());

modulos
    .onLoad('ALL', () => Video.initialize(videoJsonConfig));

modulos
    .onLoad('ALL', () => personalizacionCommon.seguirDejarSeguir(document.querySelectorAll("button.seguir")));

const ejecutarScriptsDataModulesOff = () => {
    var dataModules = document.querySelectorAll('*[data-module]');
    if (dataModules.length === 0) {
        var scripts = [];
        dataModules = document.querySelectorAll('*[data-module-js]');
        dataModules.forEach(function (el) {
            var path = el.getAttribute('data-module-js');
            var script = document.createElement('script');
            script.src = path;
            document.body.appendChild(script);
        })
    }

}


const guardarClima = () => {
    if (document.querySelector("#btnClimaHome")) {
        let btnClick = document.querySelector("#btnClimaHome");
        btnClick.addEventListener("click",
            function() {

                let ciudadClima = document.querySelector("#ciudadClima");
                let selectCiudad = document.querySelector("#ciudades");
                let currentOpt = selectCiudad.options[selectCiudad.selectedIndex];

                ciudadClima.textContent = currentOpt.text;

                $.ajax({
                    dataType: "jsonp",
                    cache: true,
                    url: window.config.Statics.ContenidosUrlRoot + "/json/pronostico/index-ciudadRef=" +
                        currentOpt.value,
                    jsonpCallback: "Pronostico",
                    success: function(json) {

                    }
                });
            });
    }
}

const initClima = () => {
    let ciudadClima = document.querySelector("#ciudadClima");

    if (ciudadClima != null) {
        let selectCiudad = document.querySelector("#ciudades");
        selectCiudad.selectedIndex = 8
        let currentOpt = selectCiudad.options[selectCiudad.selectedIndex];

        ciudadClima.textContent = currentOpt.text;

        $.ajax({
            dataType: "jsonp",
            cache: true,
            url: window.config.Statics.ContenidosUrlRoot + "/json/pronostico/index-ciudadRef=ARCF0009",
            jsonpCallback: "Pronostico",
            success: function(json) {

            }
        });
    }
}

window.pronosticoCallbackJSON = function(value) {
    let tempeClima = document.querySelector("#temperaturaClima");

    let ciudadClima = document.querySelector("#ciudadClima");
    let selectCiudad = document.querySelector("#ciudades");
    let currentOpt = selectCiudad.options[selectCiudad.selectedIndex];

    let ciudadData = value.ciudades.find(i => i.ciudad.codigo === currentOpt.value);

    tempeClima.textContent = ciudadData.ciudad.temperatura.concat("° ", ciudadData.ciudad.icono_descripcion);
    let imagenClima = document.querySelector("#imageClima");

    let idImagenClima = ciudadData.ciudad.icono_id.trim();
    let classClima = "clima-";

    imagenClima.classList.add(classClima.concat(idImagenClima));

}

const getTableros = () => {
    const tablero = document.body.querySelectorAll(".tablero");

    if (tablero.length > 0) {

        let tableros = [];
        
        let tFutbol = document.body.querySelectorAll("div.tablero.tableroFutbol");
        let tTenis = document.body.querySelectorAll("div.tablero.tableroTenis");
        let tRugby = document.body.querySelectorAll("div.tablero.tableroRugby");
        let tbasquet = document.body.querySelectorAll("div.tablero.tableroBasquet");
        let tVoley = document.body.querySelectorAll("div.tablero.tableroVoley");

        if (tFutbol != null) {
            for (let i = 0; i < tFutbol.length; i++) {
                var inicializado = tFutbol[i].getAttribute("data-inicializado");
                if (!inicializado) {
                    tableros.push(TableroFutbol.agregarTableroFutbol(tFutbol[i].getAttribute("data-id"), '1101'));
                    tFutbol[i].setAttribute("data-inicializado", 1);
                }
            }
        }
        if (tTenis != null) {
            for (let j = 0; j < tTenis.length; j++) {
                var inicializado = tTenis[j].getAttribute("data-inicializado");
                if (!inicializado) {
                    tableros.push(TableroTenis.agregarTableroTenis(tTenis[j].getAttribute("data-id"), '1000'));
                    tTenis[j].setAttribute("data-inicializado", 1);
                }
            }
        }
        if (tRugby != null) {
            for (let j = 0; j < tRugby.length; j++) {
                var inicializado = tRugby[j].getAttribute("data-inicializado");
                if (!inicializado) {
                    tableros.push(TableroRugby.agregarTableroRugby(tRugby[j].getAttribute("data-id"), '1101'));
                    tRugby[j].setAttribute("data-inicializado", 1);
                }
            }
        }
        if(tbasquet != null)
        {
            for (let j = 0; j < tbasquet.length; j++) {
                var inicializado = tbasquet[j].getAttribute("data-inicializado");
                if (!inicializado) {
                    tableros.push(TableroBasquet.agregarTableroBasket(tbasquet[j].getAttribute("data-id"), '1101'));
                    tbasquet[j].setAttribute("data-inicializado", 1);
                }
            }
        }
        if (tVoley != null) {
            for (let j = 0; j < tVoley.length; j++) {
                var inicializado = tVoley[j].getAttribute("data-inicializado");
                if (!inicializado) {
                    tableros.push(TableroVoley.agregarTableroVoley(tVoley[j].getAttribute("data-id"), '1000'));
                    tVoley[j].setAttribute("data-inicializado", 1);
                }
            }
        }
                
        
        if (tableros.length) {
            Tablero.iniciarTableros(tableros);
            Tablero.verificarCambiosCodigoControl();
            setInterval(Tablero.verificarCambiosCodigoControl, 15000);
        }
    }
}

const cxense = () => {
    let script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.innerHTML = `
    var cX = cX || {}; cX.callQueue = cX.callQueue || [];
    cX.callQueue.push(['setSiteId', '1135050122432099686']);
    cX.callQueue.push(['sendPageViewEvent']);
    (function(d,s,e,t){e = d.createElement(s); e.type='text/java'+s;e.async='async';
        e.src='http'+('https:'===location.protocol?'s://s':'://')+'cdn.cxense.com/cx.js';
        t=d.getElementsByTagName(s)[0];t.parentNode.insertBefore(e,t);})(document,'script');
    `;
    document.body.appendChild(script);
}
 
const tableroDolar = () => {
    $(function () {
        var url = 'https://api-contenidos.lanacion.com.ar/json/V3/economia/cotizacion/DBNA';
        $.get(url, function (data) {
            var arrCompra = data.compra.split(',');
            var arrVenta = data.venta.split(',');
            $('.precio-compra').html('$<span class="dolar-imp ">' + arrCompra[0] + ',</span>' + arrCompra[1] + '</p>');
            $('.precio-venta').html('$<span class="dolar-imp ">' + arrVenta[0] + ',</span>' + arrVenta[1] + '</p>');
            var pVar = $('.dolar-variacion');
            var spanIconoVar = $('.icono-variacion-dolar');
            var variacion = data.variacion.replace('-', '').replace('+', '');
            pVar.html(variacion + '%');
            if (data.aumento) {
                spanIconoVar.addClass('icon-arriba');
            } else if (!data.aumento && data.variacion != " 0,0") {
                spanIconoVar.addClass('icon-abajo');
            }
        });
    })
}


const initialize = () => {
    //Parche temporal por problemas de carga con Ipad
    var esIpad = isMobile.apple.tablet;
    Login.Initialize();
    Logout.Initialize();
    new LazyLoad({
        elements_selector: ".lazy"
    })
    if (!isMobile.apple.phone && !esIpad) pwaRegister.updateRegister(); 
    if (!esIpad) {
        const personalizacionHome = personalizacionHomeBuilder.build(prioridadTag);
        personalizacionHome.initPreferencias("home");
        personalizacionCommon.seguirDejarSeguir(document.querySelectorAll("button.seguir"));
        Functions.buscador();
        Functions.bannerHeaderLogo();
    }
    Video.initialize(videoJsonConfig);
    Pym.initIframePym();
    //COMENTO TEMPORALMENTE HASTA QUE VUELVA EL CLIMA EN EL HEADER.
    //if (!esIpad) {
    //    initClima();
    //    guardarClima();
    //} else {
    //    $('#ciudadClima').hide();
    //}
    getTableros();
    cxense();
    CustomDimension.MakeCustomDimension();

    const naveggFn = customNavegg.init(naveggCustomSegments);
    naveggFn.loadSegmentos();
    ejecutarScriptsDataModulesOff();
    pvComscore.agregarEventoScrollPageview('hoy');
    Utilities.metaRefresh(300000, "home");
}

window.app = app;
app.start().then(initialize);


// WEBPACK FOOTER //
// ./Statics/home.js